export class NameValueCodeDTO {
  value: number;
  name: string;
  code: string;
}

export function CreateNameValueCodeDTO(value: number, name: string, code: string): NameValueCodeDTO {
  const nameValueCodeDTO = new NameValueCodeDTO();
  nameValueCodeDTO.value = value;
  nameValueCodeDTO.name = name;
  nameValueCodeDTO.code = code;
  return nameValueCodeDTO;
}
